/* Internal User Model */
import { UserModel, CompanyModel, PspModel } from "./model";

// const UserModel = { hello: "asdfasd" };

/* Internal Vars */
import UserJar from "./jar";

/* Internal inititator */

/* Internal Services */
import UserService from "./service";

/* Storage */
import UserStorage from "./storage";

/* Internal Factories */

import AuthenticationModule from "./authentication/module";

/* Facades - API to other modules */
import Users from "./facade";

const modul = angular
    .module("UserModule", [AuthenticationModule])

    /**
     * Model - immuteable object
     */
    .constant("UserModel", UserModel)
    .constant("CompanyModel", CompanyModel)
    .constant("PspModel", PspModel)
    /**
     * BookingJar - Holds variables internally
     */
    .service("UserJar", UserJar)

    /**
     * Services
     * * can only have utility dependencies
     */
    .factory("UserService", UserService)

    /**
     * Storage
     * can only have utility and services as dependencies
     */
    .factory("UserStorage", UserStorage)

    /**
     * Factories
     */

    /**
     * Facades
     */
    .factory("Users", Users);

export default modul.name;
